// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FiSun,
//   FiStar,
//   FiGift,
//   FiCalendar,
//   FiClock,
//   FiMapPin,
//   FiPhone,
//   FiMail,
//   FiCheck,
//   FiX,
//   FiNavigation,
//   FiLock,
//   FiUnlock,
//   FiCreditCard,
// } from "react-icons/fi";
// import { GiTempleGate, GiFlowerPot } from "react-icons/gi";

// export default function TempleSevasPage() {
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [selectedSeva, setSelectedSeva] = useState(null);
//   const [isPaid, setIsPaid] = useState(false);
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [showCoinAnimation, setShowCoinAnimation] = useState(false);
//   const [currentImageIndex, setCurrentImageIndex] = useState({});

//   const sevaCategories = [
//     { id: "all", name: "All Sevas", icon: <GiTempleGate /> },
//     { id: "daily", name: "Daily Sevas", icon: <FiSun /> },
//     { id: "special", name: "Special Pujas", icon: <FiStar /> },
//     { id: "festival", name: "Festival Sevas", icon: <FiGift /> },
//     { id: "abhishekam", name: "Abhishekam", icon: <GiFlowerPot /> },
//   ];

//   const temples = {
//     1: {
//       name: "Sri Venkateswara Temple",
//       location: "Tirupati, Andhra Pradesh",
//       deity: "Lord Venkateswara",
//       address: "Tirumala Hills, Tirupati - 517504",
//       contact: "+91 877-2277777",
//       email: "info@tirumala.org",
//       timings: "2:30 AM - 1:00 AM (Next Day)",
//       description:
//         "One of the richest and most visited pilgrimage centers in the world",
//       facilities: ["Free WiFi", "Parking", "Prasadam Counter", "Accommodation"],
//     },
//     2: {
//       name: "Meenakshi Amman Temple",
//       location: "Madurai, Tamil Nadu",
//       deity: "Goddess Meenakshi",
//       address: "Madurai Main, Madurai - 625001",
//       contact: "+91 452-2345678",
//       email: "info@meenakshi.org",
//       timings: "5:00 AM - 12:30 PM, 4:00 PM - 9:30 PM",
//       description:
//         "Historic temple dedicated to Goddess Meenakshi and Lord Sundareswarar",
//       facilities: [
//         "Audio Guide",
//         "Museum",
//         "Prasadam Counter",
//         "Photography Area",
//       ],
//     },
//     3: {
//       name: "Somnath Temple",
//       location: "Somnath, Gujarat",
//       deity: "Lord Shiva",
//       address: "Veraval, Somnath - 362268",
//       contact: "+91 2876-231234",
//       email: "info@somnath.org",
//       timings: "6:00 AM - 9:00 PM",
//       description: "First among the twelve Jyotirlinga shrines of Lord Shiva",
//       facilities: ["Beach View", "Sound & Light Show", "Museum", "Guest House"],
//     },
//     4: {
//       name: "Jagannath Temple",
//       location: "Puri, Odisha",
//       deity: "Lord Jagannath",
//       address: "Grand Road, Puri - 752001",
//       contact: "+91 6752-222407",
//       email: "info@jagannath.org",
//       timings: "5:00 AM - 11:00 PM",
//       description:
//         "Famous Char Dham pilgrimage site dedicated to Lord Jagannath",
//       facilities: [
//         "Mahaprasad",
//         "Heritage Site",
//         "Beach Nearby",
//         "Accommodation",
//       ],
//     },
//     5: {
//       name: "Kashi Vishwanath Temple",
//       location: "Varanasi, Uttar Pradesh",
//       deity: "Lord Shiva",
//       address: "Lahori Tola, Varanasi - 221001",
//       contact: "+91 542-2392569",
//       email: "info@kashivishwanath.org",
//       timings: "3:00 AM - 11:00 PM",
//       description: "One of the most sacred Shiva temples and Jyotirlinga",
//       facilities: [
//         "Ganga Ghat Nearby",
//         "Special Darshan",
//         "Prasadam",
//         "Security Locker",
//       ],
//     },
//   };

//   const sevas = [
//     {
//       id: 1,
//       name: "Suprabhatam Seva",
//       templeId: 1,
//       category: "daily",
//       description: "Morning awakening seva with sacred hymns and offerings",
//       duration: "30 mins",
//       price: "₹500",
//       time: "5:00 AM - 6:00 AM",
//       images: [
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=400&h=300&fit=crop",
//       ],
//       benefits: [
//         "Early morning blessings",
//         "Divine awakening",
//         "Positive energy",
//       ],
//     },
//     {
//       id: 2,
//       name: "Abhishekam Seva",
//       templeId: 1,
//       category: "abhishekam",
//       description: "Sacred bathing ritual with milk, honey, and holy water",
//       duration: "45 mins",
//       price: "₹1,100",
//       time: "6:30 AM - 7:15 AM",
//       images: [
//         "https://images.unsplash.com/photo-1583934443442-0b0b0b0b0b0b?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1585937421612-70e008356f9b?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1515191107209-c28698631303?w=400&h=300&fit=crop",
//       ],
//       benefits: ["Purification", "Divine grace", "Spiritual cleansing"],
//     },
//     {
//       id: 3,
//       name: "Sahasranama Archana",
//       templeId: 2,
//       category: "special",
//       description: "Chanting of 1000 names with flower offerings",
//       duration: "1 hour",
//       price: "₹2,100",
//       time: "8:00 AM - 9:00 AM",
//       images: [
//         "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//       ],
//       benefits: ["Divine blessings", "Mental peace", "Prosperity"],
//     },
//     {
//       id: 4,
//       name: "Ekadasa Rudrabhishekam",
//       templeId: 3,
//       category: "abhishekam",
//       description: "11 Rudra abhishekam with sacred mantras",
//       duration: "2 hours",
//       price: "₹5,500",
//       time: "7:00 AM - 9:00 AM",
//       images: [
//         "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
//       ],
//       benefits: [
//         "Removal of obstacles",
//         "Health & wealth",
//         "Divine protection",
//       ],
//     },
//     {
//       id: 5,
//       name: "Lakshmi Puja",
//       templeId: 2,
//       category: "special",
//       description: "Special worship for wealth and prosperity",
//       duration: "1.5 hours",
//       price: "₹3,100",
//       time: "6:00 PM - 7:30 PM",
//       images: [
//         "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=400&h=300&fit=crop",
//       ],
//       benefits: ["Wealth attraction", "Business success", "Family prosperity"],
//     },
//     {
//       id: 6,
//       name: "Navagraha Shanti Puja",
//       templeId: 4,
//       category: "special",
//       description: "Worship of nine planets for cosmic harmony",
//       duration: "2 hours",
//       price: "₹4,500",
//       time: "10:00 AM - 12:00 PM",
//       images: [
//         "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1585937421612-70e008356f9b?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
//       ],
//       benefits: ["Planetary peace", "Life balance", "Good fortune"],
//     },
//     {
//       id: 7,
//       name: "Mahanyasa Purvaka Rudrabhishekam",
//       templeId: 3,
//       category: "festival",
//       description: "Grand abhishekam with elaborate rituals",
//       duration: "3 hours",
//       price: "₹11,000",
//       time: "6:00 AM - 9:00 AM",
//       images: [
//         "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
//       ],
//       benefits: [
//         "Supreme blessings",
//         "Life transformation",
//         "Spiritual elevation",
//       ],
//     },
//     {
//       id: 8,
//       name: "Annadanam Seva",
//       templeId: 1,
//       category: "daily",
//       description: "Food offering seva - feed devotees in temple",
//       duration: "Full day",
//       price: "₹15,000",
//       time: "12:00 PM - 2:00 PM",
//       images: [
//         "https://images.unsplash.com/photo-1585937421612-70e008356f9b?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
//         "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
//       ],
//       benefits: ["Abundant blessings", "Karma cleansing", "Divine merit"],
//     },
//   ];

//   const filteredSevas =
//     selectedCategory === "all"
//       ? sevas
//       : sevas.filter((seva) => seva.category === selectedCategory);

//   const handleBookSeva = (seva) => {
//     setSelectedSeva(seva);
//     setIsPaid(false);
//     setShowPaymentModal(false);
//     setSelectedPaymentMethod(null);
//     setIsProcessing(false);
//   };

//   const handlePayment = () => {
//     setShowPaymentModal(true);
//     setSelectedPaymentMethod(null);
//   };

//   const handlePaymentMethodSelect = (method) => {
//     setSelectedPaymentMethod(method);
//   };

//   const handlePaymentSuccess = () => {
//     setIsProcessing(true);
//     setShowCoinAnimation(true);

//     // Simulate payment processing with coin animation
//     setTimeout(() => {
//       setShowCoinAnimation(false);
//       setIsProcessing(false);
//       setIsPaid(true);
//       setShowPaymentModal(false);
//       setSelectedPaymentMethod(null);
//     }, 3000);
//   };

//   const maskText = (text) => {
//     if (!text) return "***************";
//     return "*".repeat(Math.min(text.length, 15));
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-orange-50">
//       {/* Hero Section */}
//       <div className="relative bg-gradient-to-r from-orange-600 via-red-600 to-orange-700 text-white py-12 mt-20 overflow-hidden">

//          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             className="text-center"
//           >
//             <div className="flex items-center justify-center gap-12 mb-4">
//               <h1 className="text-xl md:text-5xl lg:text-6xl font-bold font-serif">
//                 Temple Sevas
//               </h1>
//             </div>
//             <p className="text-lg md:text-xl text-orange-100 max-w-3xl mx-auto">
//               Experience divine blessings through sacred temple rituals
//             </p>
//           </motion.div>
//         </div>
//         {/* Category Filter */}
//         <div className="max-w-9xl mx-auto ">
//           {/* Decorative Temple Icon */}
//           <motion.div
//             initial={{ scale: 0, rotate: -180 }}
//             animate={{ scale: 1, rotate: 0 }}
//             transition={{ duration: 0.6, delay: 0.1 }}
//             className="flex justify-center mb-4"
//           ></motion.div>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//             className="bg-white rounded-full shadow-2xl p-3 border border-orange-100"
//           >
//             <div className="flex flex-wrap gap-2 md:gap-3 justify-center items-center">
//               {sevaCategories.map((category) => (
//                 <motion.button
//                   key={category.id}
//                   onClick={() => setSelectedCategory(category.id)}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className={`flex items-center gap-2 px-5 md:px-7 py-2.5 md:py-3 rounded-full font-semibold transition-all duration-300 text-sm md:text-base shadow-md ${
//                     selectedCategory === category.id
//                       ? "bg-gradient-to-r from-orange-500 to-red-600 text-white shadow-lg scale-105"
//                       : "bg-gradient-to-r from-gray-50 to-gray-100 text-gray-700 hover:from-orange-50 hover:to-red-50 hover:text-orange-600 hover:shadow-lg"
//                   }`}
//                 >
//                   <span className="text-xl md:text-2xl">{category.icon}</span>
//                   <span className="hidden sm:inline whitespace-nowrap">
//                     {category.name}
//                   </span>
//                   <span className="sm:hidden whitespace-nowrap">
//                     {category.name.split(" ")[0]}
//                   </span>
//                 </motion.button>
//               ))}
//             </div>
//           </motion.div>
//         </div>
//       </div>

//       {/* Sevas Grid - Modern Compact Cards */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-9">
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
//           {filteredSevas.map((seva, index) => {
//             const temple = temples[seva.templeId];
//             return (
//               <motion.div
//                 key={seva.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.4, delay: index * 0.05 }}
//                 className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 group hover:-translate-y-1"
//               >
//                 {/* Card Header with Image Slider */}
//                 <div className="relative h-36 overflow-hidden">
//                   {/* Images */}
//                   {seva.images.map((img, imgIndex) => (
//                     <motion.img
//                       key={imgIndex}
//                       src={img}
//                       alt={`${seva.name} ${imgIndex + 1}`}
//                       className="absolute w-full h-full object-cover"
//                       initial={{ opacity: imgIndex === 0 ? 1 : 0 }}
//                       animate={{
//                         opacity:
//                           (currentImageIndex[seva.id] || 0) === imgIndex
//                             ? 1
//                             : 0,
//                         scale:
//                           (currentImageIndex[seva.id] || 0) === imgIndex
//                             ? 1
//                             : 1.1,
//                       }}
//                       transition={{ duration: 0.5 }}
//                     />
//                   ))}

//                   <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />

//                   {/* Navigation Arrows */}
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentImageIndex((prev) => ({
//                         ...prev,
//                         [seva.id]:
//                           ((prev[seva.id] || 0) - 1 + seva.images.length) %
//                           seva.images.length,
//                       }));
//                     }}
//                     className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-1.5 rounded-full backdrop-blur-sm transition-all z-10 opacity-0 group-hover:opacity-100"
//                   >
//                     <svg
//                       className="w-4 h-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M15 19l-7-7 7-7"
//                       />
//                     </svg>
//                   </button>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentImageIndex((prev) => ({
//                         ...prev,
//                         [seva.id]:
//                           ((prev[seva.id] || 0) + 1) % seva.images.length,
//                       }));
//                     }}
//                     className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-1.5 rounded-full backdrop-blur-sm transition-all z-10 opacity-0 group-hover:opacity-100"
//                   >
//                     <svg
//                       className="w-4 h-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M9 5l7 7-7 7"
//                       />
//                     </svg>
//                   </button>

//                   {/* Image Indicators */}
//                   <div className="absolute bottom-14 left-0 right-0 flex justify-center gap-1.5 z-10">
//                     {seva.images.map((_, imgIndex) => (
//                       <button
//                         key={imgIndex}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setCurrentImageIndex((prev) => ({
//                             ...prev,
//                             [seva.id]: imgIndex,
//                           }));
//                         }}
//                         className={`w-1.5 h-1.5 rounded-full transition-all ${
//                           (currentImageIndex[seva.id] || 0) === imgIndex
//                             ? "bg-white w-4"
//                             : "bg-white/50 hover:bg-white/75"
//                         }`}
//                       />
//                     ))}
//                   </div>

//                   {/* Temple Name */}
//                   <div className="absolute bottom-2 left-3 right-3">
//                     <div className="flex items-center gap-1.5 text-xs text-white/95 mb-1 bg-black/40 backdrop-blur-sm px-2 py-1 rounded-md">
//                       <GiTempleGate className="w-3.5 h-3.5 flex-shrink-0" />
//                       <span className="truncate font-medium">
//                         {temple?.name}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Card Body */}
//                 <div className="p-4">
//                   <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-1">
//                     {seva.name}
//                   </h3>

//                   <p className="text-xs text-gray-600 mb-3 line-clamp-2 leading-relaxed">
//                     {seva.description}
//                   </p>

//                   {/* Book Button */}
//                   <button
//                     onClick={() => handleBookSeva(seva)}
//                     className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white py-2.5 rounded-lg font-semibold hover:from-orange-600 hover:to-red-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm flex items-center justify-center gap-2"
//                   >
//                     <FiCalendar className="w-4 h-4" />
//                     <span>Book This Seva</span>
//                   </button>
//                 </div>
//               </motion.div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Booking Modal */}
//       <AnimatePresence>
//         {selectedSeva && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
//             onClick={() => setSelectedSeva(null)}
//           >
//             <motion.div
//               initial={{ scale: 0.9, y: 20 }}
//               animate={{ scale: 1, y: 0 }}
//               exit={{ scale: 0.9, y: 20 }}
//               className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Modal Header */}
//               <div className="sticky top-0 bg-gradient-to-r from-orange-500 to-red-600 text-white p-6 rounded-t-2xl z-10">
//                 <button
//                   onClick={() => setSelectedSeva(null)}
//                   className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-colors"
//                 >
//                   <FiX className="w-6 h-6" />
//                 </button>
//                 <h2 className="text-2xl md:text-3xl font-bold mb-2 pr-10">
//                   {selectedSeva.name}
//                 </h2>
//                 <p className="text-orange-100 text-sm md:text-base">
//                   {temples[selectedSeva.templeId]?.name}
//                 </p>
//               </div>

//               {/* Modal Body */}
//               <div className="p-6">
//                 <div className="grid grid-cols-1 gap-6 mb-6">
//                   {/* Seva Image Slider */}
//                   <div className="rounded-xl overflow-hidden shadow-lg relative group">
//                     {/* Images */}
//                     {selectedSeva.images.map((img, imgIndex) => (
//                       <motion.img
//                         key={imgIndex}
//                         src={img}
//                         alt={`${selectedSeva.name} ${imgIndex + 1}`}
//                         className="w-full h-64 object-cover"
//                         initial={{ opacity: imgIndex === 0 ? 1 : 0 }}
//                         animate={{
//                           opacity:
//                             (currentImageIndex[`modal-${selectedSeva.id}`] ||
//                               0) === imgIndex
//                               ? 1
//                               : 0,
//                         }}
//                         transition={{ duration: 0.5 }}
//                         style={{
//                           position: imgIndex === 0 ? "relative" : "absolute",
//                           top: 0,
//                           left: 0,
//                           right: 0,
//                         }}
//                       />
//                     ))}

//                     {/* Navigation Arrows */}
//                     <button
//                       onClick={() => {
//                         setCurrentImageIndex((prev) => ({
//                           ...prev,
//                           [`modal-${selectedSeva.id}`]:
//                             ((prev[`modal-${selectedSeva.id}`] || 0) -
//                               1 +
//                               selectedSeva.images.length) %
//                             selectedSeva.images.length,
//                         }));
//                       }}
//                       className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full backdrop-blur-sm transition-all z-10 opacity-0 group-hover:opacity-100"
//                     >
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M15 19l-7-7 7-7"
//                         />
//                       </svg>
//                     </button>
//                     <button
//                       onClick={() => {
//                         setCurrentImageIndex((prev) => ({
//                           ...prev,
//                           [`modal-${selectedSeva.id}`]:
//                             ((prev[`modal-${selectedSeva.id}`] || 0) + 1) %
//                             selectedSeva.images.length,
//                         }));
//                       }}
//                       className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full backdrop-blur-sm transition-all z-10 opacity-0 group-hover:opacity-100"
//                     >
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 5l7 7-7 7"
//                         />
//                       </svg>
//                     </button>

//                     {/* Image Indicators */}
//                     <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10">
//                       {selectedSeva.images.map((_, imgIndex) => (
//                         <button
//                           key={imgIndex}
//                           onClick={() => {
//                             setCurrentImageIndex((prev) => ({
//                               ...prev,
//                               [`modal-${selectedSeva.id}`]: imgIndex,
//                             }));
//                           }}
//                           className={`h-2 rounded-full transition-all ${
//                             (currentImageIndex[`modal-${selectedSeva.id}`] ||
//                               0) === imgIndex
//                               ? "bg-white w-8"
//                               : "bg-white/50 hover:bg-white/75 w-2"
//                           }`}
//                         />
//                       ))}
//                     </div>
//                   </div>

//                   {/* Seva Description */}
//                   <div>
//                     <h3 className="text-lg font-bold text-gray-900 mb-2">
//                       About This Seva
//                     </h3>
//                     <p className="text-gray-600 leading-relaxed">
//                       {selectedSeva.description}
//                     </p>
//                   </div>
//                 </div>

//                 {/* Benefits */}
//                 <div className="mb-6">
//                   <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
//                     <FiStar className="text-orange-500" />
//                     Spiritual Benefits
//                   </h3>
//                   <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//                     {selectedSeva.benefits.map((benefit, idx) => (
//                       <div
//                         key={idx}
//                         className="flex items-center gap-2 bg-green-50 p-3 rounded-lg"
//                       >
//                         <FiCheck className="w-5 h-5 text-green-600 flex-shrink-0" />
//                         <span className="text-sm text-gray-700">{benefit}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Temple Information - Masked/Unmasked */}
//                 <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6 border border-orange-100 relative overflow-hidden">
//                   {/* Lock/Unlock Icon Badge */}
//                   <div className="absolute top-4 right-4">
//                     {isPaid ? (
//                       <div className="bg-green-500 text-white p-2 rounded-full shadow-lg">
//                         <FiUnlock className="w-5 h-5" />
//                       </div>
//                     ) : (
//                       <div className="bg-orange-500 text-white p-2 rounded-full shadow-lg animate-pulse">
//                         <FiLock className="w-5 h-5" />
//                       </div>
//                     )}
//                   </div>

//                   <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
//                     <GiTempleGate className="text-orange-600" />
//                     Temple Information {!isPaid && "(🔒 Locked)"}
//                   </h3>

//                   {!isPaid ? (
//                     <>
//                       {/* Partially Masked Information */}
//                       <div className="space-y-4 mb-6">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                           {/* Temple Name - SHOWN */}
//                           <div>
//                             <p className="text-sm text-gray-600 mb-1">
//                               Temple Name
//                             </p>
//                             <div className="bg-white px-4 py-3 rounded-lg border border-orange-200">
//                               <p className="font-semibold text-gray-900">
//                                 {temples[selectedSeva.templeId]?.name}
//                               </p>
//                             </div>
//                           </div>

//                           {/* Deity - SHOWN */}
//                           <div>
//                             <p className="text-sm text-gray-600 mb-1">Deity</p>
//                             <div className="bg-white px-4 py-3 rounded-lg border border-orange-200">
//                               <p className="font-semibold text-gray-900">
//                                 {temples[selectedSeva.templeId]?.deity}
//                               </p>
//                             </div>
//                           </div>

//                           {/* Location - MASKED */}
//                           <div className="relative">
//                             <p className="text-sm text-gray-600 mb-1">
//                               Location 🔒
//                             </p>
//                             <div className="bg-white/50 backdrop-blur-sm px-4 py-3 rounded-lg border border-orange-200 relative overflow-hidden">
//                               <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
//                               <p className="font-mono text-gray-400 blur-sm select-none flex items-center gap-2">
//                                 <FiMapPin className="w-4 h-4 text-orange-400" />
//                                 {maskText(
//                                   temples[selectedSeva.templeId]?.location
//                                 )}
//                               </p>
//                             </div>
//                           </div>

//                           {/* Temple Timings - MASKED */}
//                           <div className="relative">
//                             <p className="text-sm text-gray-600 mb-1">
//                               Temple Timings 🔒
//                             </p>
//                             <div className="bg-white/50 backdrop-blur-sm px-4 py-3 rounded-lg border border-orange-200 relative overflow-hidden">
//                               <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
//                               <p className="font-mono text-gray-400 blur-sm select-none">
//                                 {maskText(
//                                   temples[selectedSeva.templeId]?.timings
//                                 )}
//                               </p>
//                             </div>
//                           </div>

//                           {/* Address - MASKED */}
//                           <div className="md:col-span-2 relative">
//                             <p className="text-sm text-gray-600 mb-1">
//                               Address 🔒
//                             </p>
//                             <div className="bg-white/50 backdrop-blur-sm px-4 py-3 rounded-lg border border-orange-200 relative overflow-hidden">
//                               <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
//                               <p className="font-mono text-gray-400 blur-sm select-none">
//                                 {maskText(
//                                   temples[selectedSeva.templeId]?.address
//                                 )}
//                               </p>
//                             </div>
//                           </div>

//                           {/* Contact - MASKED */}
//                           <div className="relative">
//                             <p className="text-sm text-gray-600 mb-1">
//                               Contact 🔒
//                             </p>
//                             <div className="bg-white/50 backdrop-blur-sm px-4 py-3 rounded-lg border border-orange-200 relative overflow-hidden">
//                               <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
//                               <p className="font-mono text-gray-400 blur-sm select-none flex items-center gap-2">
//                                 <FiPhone className="w-4 h-4 text-orange-400" />
//                                 {maskText(
//                                   temples[selectedSeva.templeId]?.contact
//                                 )}
//                               </p>
//                             </div>
//                           </div>

//                           {/* Email - MASKED */}
//                           <div className="relative">
//                             <p className="text-sm text-gray-600 mb-1">
//                               Email 🔒
//                             </p>
//                             <div className="bg-white/50 backdrop-blur-sm px-4 py-3 rounded-lg border border-orange-200 relative overflow-hidden">
//                               <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
//                               <p className="font-mono text-gray-400 blur-sm select-none flex items-center gap-2">
//                                 <FiMail className="w-4 h-4 text-orange-400" />
//                                 {maskText(
//                                   temples[selectedSeva.templeId]?.email
//                                 )}
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Payment Required Message */}
//                       <div className="bg-gradient-to-r from-orange-100 to-red-100 border-2 border-orange-300 rounded-xl p-5">
//                         <div className="flex items-start gap-4">
//                           <div className="bg-orange-500 text-white p-3 rounded-full flex-shrink-0">
//                             <FiLock className="w-6 h-6" />
//                           </div>
//                           <div className="flex-1">
//                             <h4 className="font-bold text-gray-900 text-lg mb-2">
//                               Complete Payment to Unlock Temple Details
//                             </h4>
//                             <p className="text-gray-700 text-sm leading-relaxed mb-3">
//                               To access complete temple information including
//                               contact details, address, and booking
//                               confirmation, please complete the payment.
//                               Platform charges apply.
//                             </p>
//                             <div className="flex items-center gap-2 text-sm text-gray-600">
//                               <FiCheck className="w-4 h-4 text-green-600" />
//                               <span>Secure payment gateway</span>
//                             </div>
//                             <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
//                               <FiCheck className="w-4 h-4 text-green-600" />
//                               <span>Instant access after payment</span>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     <>
//                       {/* Unmasked Information */}
//                       <div className="mb-4">
//                         <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
//                           <div className="flex items-center gap-2 text-green-700">
//                             <FiUnlock className="w-5 h-5" />
//                             <span className="font-semibold">
//                               Payment Successful! Temple details unlocked.
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div>
//                           <p className="text-sm text-gray-600 mb-1">
//                             Temple Name
//                           </p>
//                           <p className="font-semibold text-gray-900 bg-white px-4 py-2 rounded-lg">
//                             {temples[selectedSeva.templeId]?.name}
//                           </p>
//                         </div>
//                         <div>
//                           <p className="text-sm text-gray-600 mb-1">Deity</p>
//                           <p className="font-semibold text-gray-900 bg-white px-4 py-2 rounded-lg">
//                             {temples[selectedSeva.templeId]?.deity}
//                           </p>
//                         </div>
//                         <div>
//                           <p className="text-sm text-gray-600 mb-1">Location</p>
//                           <p className="font-semibold text-gray-900 flex items-start gap-2 bg-white px-4 py-2 rounded-lg">
//                             <FiMapPin className="w-4 h-4 text-orange-500 mt-1 flex-shrink-0" />
//                             <span>
//                               {temples[selectedSeva.templeId]?.location}
//                             </span>
//                           </p>
//                         </div>
//                         <div>
//                           <p className="text-sm text-gray-600 mb-1">
//                             Temple Timings
//                           </p>
//                           <p className="font-semibold text-gray-900 bg-white px-4 py-2 rounded-lg">
//                             {temples[selectedSeva.templeId]?.timings}
//                           </p>
//                         </div>
//                         <div className="md:col-span-2">
//                           <p className="text-sm text-gray-600 mb-1">Address</p>
//                           <p className="font-semibold text-gray-900 bg-white px-4 py-2 rounded-lg">
//                             {temples[selectedSeva.templeId]?.address}
//                           </p>
//                         </div>
//                         <div>
//                           <p className="text-sm text-gray-600 mb-1">Contact</p>
//                           <p className="font-semibold text-gray-900 flex items-center gap-2 bg-white px-4 py-2 rounded-lg">
//                             <FiPhone className="w-4 h-4 text-orange-500" />
//                             <a
//                               href={`tel:${
//                                 temples[selectedSeva.templeId]?.contact
//                               }`}
//                               className="hover:text-orange-600"
//                             >
//                               {temples[selectedSeva.templeId]?.contact}
//                             </a>
//                           </p>
//                         </div>
//                         <div>
//                           <p className="text-sm text-gray-600 mb-1">Email</p>
//                           <p className="font-semibold text-gray-900 flex items-center gap-2 bg-white px-4 py-2 rounded-lg">
//                             <FiMail className="w-4 h-4 text-orange-500" />
//                             <a
//                               href={`mailto:${
//                                 temples[selectedSeva.templeId]?.email
//                               }`}
//                               className="hover:text-orange-600"
//                             >
//                               {temples[selectedSeva.templeId]?.email}
//                             </a>
//                           </p>
//                         </div>
//                       </div>

//                       <div className="mt-4">
//                         <p className="text-sm text-gray-600 mb-2">
//                           About Temple
//                         </p>
//                         <p className="text-gray-700 leading-relaxed bg-white px-4 py-3 rounded-lg">
//                           {temples[selectedSeva.templeId]?.description}
//                         </p>
//                       </div>

//                       <div className="mt-4">
//                         <p className="text-sm text-gray-600 mb-2">Facilities</p>
//                         <div className="flex flex-wrap gap-2">
//                           {temples[selectedSeva.templeId]?.facilities.map(
//                             (facility, idx) => (
//                               <span
//                                 key={idx}
//                                 className="bg-white px-3 py-1 rounded-full text-sm text-gray-700 border border-orange-200"
//                               >
//                                 {facility}
//                               </span>
//                             )
//                           )}
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="mt-6 flex flex-col sm:flex-row gap-3">
//                   {!isPaid ? (
//                     <button
//                       onClick={handlePayment}
//                       className="flex-1 bg-gradient-to-r from-orange-500 to-red-600 text-white py-4 rounded-xl font-bold hover:from-orange-600 hover:to-red-700 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 text-lg"
//                     >
//                       <FiCreditCard className="w-5 h-5" />
//                       <span>Pay & Unlock Details</span>
//                     </button>
//                   ) : (
//                     <>
//                       <button className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-4 rounded-xl font-bold hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 text-lg">
//                         <FiCalendar className="w-5 h-5" />
//                         <span>Confirm Booking</span>
//                       </button>
//                       <button className="flex-1 bg-white border-2 border-orange-500 text-orange-600 py-4 rounded-xl font-bold hover:bg-orange-50 transition-all duration-300 flex items-center justify-center gap-2 text-lg">
//                         <FiNavigation className="w-5 h-5" />
//                         <span>Get Directions</span>
//                       </button>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Payment Modal */}
//       <AnimatePresence>
//         {showPaymentModal && !selectedPaymentMethod && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[60] flex items-center justify-center p-4"
//             onClick={() => setShowPaymentModal(false)}
//           >
//             <motion.div
//               initial={{ scale: 0.9, y: 20 }}
//               animate={{ scale: 1, y: 0 }}
//               exit={{ scale: 0.9, y: 20 }}
//               className="bg-white rounded-2xl max-w-md w-full shadow-2xl"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Payment Header */}
//               <div className="bg-gradient-to-r from-orange-500 to-red-600 text-white p-6 rounded-t-2xl relative">
//                 <button
//                   onClick={() => setShowPaymentModal(false)}
//                   className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-colors"
//                 >
//                   <FiX className="w-5 h-5" />
//                 </button>
//                 <div className="flex items-center gap-3">
//                   <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm">
//                     <FiCreditCard className="w-6 h-6" />
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-bold">Select Payment Method</h3>
//                     <p className="text-orange-100 text-sm">Choose how to pay</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Payment Body */}
//               <div className="p-6">
//                 {/* Booking Summary */}
//                 <div className="bg-orange-50 rounded-lg p-4 mb-6 border border-orange-200">
//                   <h4 className="font-bold text-gray-900 mb-3">
//                     Booking Summary
//                   </h4>
//                   <div className="space-y-2 text-sm">
//                     <div className="flex justify-between">
//                       <span className="text-gray-600">Seva Name:</span>
//                       <span className="font-semibold text-gray-900 text-right max-w-[60%] truncate">
//                         {selectedSeva?.name}
//                       </span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span className="text-gray-600">Duration:</span>
//                       <span className="font-semibold text-gray-900">
//                         {selectedSeva?.duration}
//                       </span>
//                     </div>
//                     <div className="border-t border-orange-300 my-2 pt-2"></div>
//                     <div className="flex justify-between">
//                       <span className="text-gray-600">Seva Price:</span>
//                       <span className="font-semibold text-gray-900">
//                         {selectedSeva?.price}
//                       </span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span className="text-gray-600">Platform Fee:</span>
//                       <span className="font-semibold text-gray-900">₹50</span>
//                     </div>
//                     <div className="border-t-2 border-orange-400 my-2 pt-2"></div>
//                     <div className="flex justify-between text-lg">
//                       <span className="font-bold text-gray-900">
//                         Total Amount:
//                       </span>
//                       <span className="font-bold text-orange-600">
//                         ₹
//                         {parseInt(
//                           selectedSeva?.price.replace("₹", "").replace(",", "")
//                         ) + 50}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Payment Method Cards */}
//                 <div className="space-y-3">
//                   {/* UPI Payment */}
//                   <motion.button
//                     whileHover={{ scale: 1.02 }}
//                     whileTap={{ scale: 0.98 }}
//                     onClick={() => handlePaymentMethodSelect("upi")}
//                     className="w-full p-4 border-2 border-orange-200 rounded-xl hover:border-orange-500 hover:bg-orange-50 transition-all duration-200 group"
//                   >
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center gap-4">
//                         <div className="bg-gradient-to-br from-purple-500 to-purple-600 p-3 rounded-lg group-hover:shadow-lg transition-shadow">
//                           <svg
//                             className="w-8 h-8 text-white"
//                             fill="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm7 2a5 5 0 0 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
//                           </svg>
//                         </div>
//                         <div className="text-left">
//                           <p className="font-bold text-gray-900 text-lg">
//                             UPI Payment
//                           </p>
//                           <p className="text-sm text-gray-600">
//                             Google Pay, PhonePe, Paytm
//                           </p>
//                         </div>
//                       </div>
//                       <FiNavigation className="w-5 h-5 text-orange-500 group-hover:translate-x-1 transition-transform" />
//                     </div>
//                   </motion.button>

//                   {/* Card Payment */}
//                   <motion.button
//                     whileHover={{ scale: 1.02 }}
//                     whileTap={{ scale: 0.98 }}
//                     onClick={() => handlePaymentMethodSelect("card")}
//                     className="w-full p-4 border-2 border-orange-200 rounded-xl hover:border-orange-500 hover:bg-orange-50 transition-all duration-200 group"
//                   >
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center gap-4">
//                         <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 rounded-lg group-hover:shadow-lg transition-shadow">
//                           <FiCreditCard className="w-8 h-8 text-white" />
//                         </div>
//                         <div className="text-left">
//                           <p className="font-bold text-gray-900 text-lg">
//                             Card Payment
//                           </p>
//                           <p className="text-sm text-gray-600">
//                             Credit / Debit Card
//                           </p>
//                         </div>
//                       </div>
//                       <FiNavigation className="w-5 h-5 text-orange-500 group-hover:translate-x-1 transition-transform" />
//                     </div>
//                   </motion.button>
//                 </div>

//                 {/* Security Notice */}
//                 <div className="mt-6 flex items-center justify-center gap-2 text-xs text-gray-500">
//                   <FiLock className="w-3 h-3" />
//                   <span>Secured by 256-bit SSL encryption</span>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* UPI Payment Modal */}
//       <AnimatePresence>
//         {selectedPaymentMethod === "upi" && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[70] flex items-center justify-center p-4"
//             onClick={() => !isProcessing && setSelectedPaymentMethod(null)}
//           >
//             <motion.div
//               initial={{ scale: 0.9, y: 20 }}
//               animate={{ scale: 1, y: 0 }}
//               exit={{ scale: 0.9, y: 20 }}
//               className="bg-white rounded-2xl max-w-md w-full shadow-2xl relative overflow-hidden"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Coin Animation */}
//               {showCoinAnimation && (
//                 <div className="absolute inset-0 pointer-events-none z-50">
//                   {[...Array(15)].map((_, i) => (
//                     <motion.div
//                       key={i}
//                       initial={{
//                         x: Math.random() * 400,
//                         y: -20,
//                         scale: 0,
//                         rotate: 0,
//                       }}
//                       animate={{
//                         y: 500,
//                         scale: [0, 1, 1, 0],
//                         rotate: 360 * (Math.random() > 0.5 ? 1 : -1),
//                       }}
//                       transition={{
//                         duration: 2,
//                         delay: i * 0.1,
//                         ease: "easeIn",
//                       }}
//                       className="absolute"
//                       style={{ left: `${Math.random() * 100}%` }}
//                     >
//                       <div className="text-4xl">🪙</div>
//                     </motion.div>
//                   ))}
//                 </div>
//               )}

//               {/* Header */}
//               <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white p-6 rounded-t-2xl relative">
//                 {!isProcessing && (
//                   <button
//                     onClick={() => setSelectedPaymentMethod(null)}
//                     className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-colors"
//                   >
//                     <FiX className="w-5 h-5" />
//                   </button>
//                 )}
//                 <div className="flex items-center gap-3">
//                   <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm">
//                     <svg
//                       className="w-6 h-6"
//                       fill="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm7 2a5 5 0 0 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
//                     </svg>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-bold">UPI Payment</h3>
//                     <p className="text-purple-100 text-sm">
//                       Complete your payment
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Body */}
//               <div className="p-6">
//                 {!isProcessing ? (
//                   <>
//                     {/* QR Code Placeholder */}
//                     <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 mb-6 flex flex-col items-center">
//                       <div className="bg-white p-4 rounded-lg shadow-lg mb-4">
//                         <div className="w-48 h-48 bg-gray-200 rounded-lg flex items-center justify-center">
//                           <div className="text-center">
//                             <div className="text-6xl mb-2">📱</div>
//                             <p className="text-sm text-gray-600">
//                               Scan QR Code
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                       <p className="text-sm text-gray-600 text-center mb-2">
//                         Scan with any UPI app
//                       </p>
//                       <p className="font-bold text-purple-600 text-lg">
//                         ₹
//                         {parseInt(
//                           selectedSeva?.price.replace("₹", "").replace(",", "")
//                         ) + 50}
//                       </p>
//                     </div>

//                     {/* UPI ID Input */}
//                     <div className="mb-6">
//                       <label className="block text-sm font-semibold text-gray-700 mb-2">
//                         Or enter UPI ID
//                       </label>
//                       <input
//                         type="text"
//                         placeholder="yourname@upi"
//                         className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none transition-colors"
//                       />
//                     </div>

//                     {/* Pay Button */}
//                     <button
//                       onClick={handlePaymentSuccess}
//                       className="w-full bg-gradient-to-r from-purple-500 to-purple-600 text-white py-4 rounded-xl font-bold hover:from-purple-600 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
//                     >
//                       <FiCheck className="w-5 h-5" />
//                       <span>Pay Now</span>
//                     </button>
//                   </>
//                 ) : (
//                   <div className="py-8 text-center">
//                     <motion.div
//                       animate={{ rotate: 360 }}
//                       transition={{
//                         duration: 1,
//                         repeat: Infinity,
//                         ease: "linear",
//                       }}
//                       className="w-16 h-16 border-4 border-purple-200 border-t-purple-600 rounded-full mx-auto mb-4"
//                     />
//                     <p className="text-lg font-semibold text-gray-900 mb-2">
//                       Processing Payment...
//                     </p>
//                     <p className="text-sm text-gray-600">Please wait</p>
//                   </div>
//                 )}
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Card Payment Modal */}
//       <AnimatePresence>
//         {selectedPaymentMethod === "card" && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[70] flex items-center justify-center p-4"
//             onClick={() => !isProcessing && setSelectedPaymentMethod(null)}
//           >
//             <motion.div
//               initial={{ scale: 0.9, y: 20 }}
//               animate={{ scale: 1, y: 0 }}
//               exit={{ scale: 0.9, y: 20 }}
//               className="bg-white rounded-2xl max-w-md w-full shadow-2xl relative overflow-hidden"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Coin Animation */}
//               {showCoinAnimation && (
//                 <div className="absolute inset-0 pointer-events-none z-50">
//                   {[...Array(15)].map((_, i) => (
//                     <motion.div
//                       key={i}
//                       initial={{
//                         x: Math.random() * 400,
//                         y: -20,
//                         scale: 0,
//                         rotate: 0,
//                       }}
//                       animate={{
//                         y: 500,
//                         scale: [0, 1, 1, 0],
//                         rotate: 360 * (Math.random() > 0.5 ? 1 : -1),
//                       }}
//                       transition={{
//                         duration: 2,
//                         delay: i * 0.1,
//                         ease: "easeIn",
//                       }}
//                       className="absolute"
//                       style={{ left: `${Math.random() * 100}%` }}
//                     >
//                       <div className="text-4xl">🪙</div>
//                     </motion.div>
//                   ))}
//                 </div>
//               )}

//               {/* Header */}
//               <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-6 rounded-t-2xl relative">
//                 {!isProcessing && (
//                   <button
//                     onClick={() => setSelectedPaymentMethod(null)}
//                     className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-colors"
//                   >
//                     <FiX className="w-5 h-5" />
//                   </button>
//                 )}
//                 <div className="flex items-center gap-3">
//                   <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm">
//                     <FiCreditCard className="w-6 h-6" />
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-bold">Card Payment</h3>
//                     <p className="text-blue-100 text-sm">Enter card details</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Body */}
//               <div className="p-6">
//                 {!isProcessing ? (
//                   <>
//                     {/* Card Display */}
//                     <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 mb-6 text-white shadow-xl">
//                       <div className="flex justify-between items-start mb-8">
//                         <div className="text-sm">Credit/Debit Card</div>
//                         <FiCreditCard className="w-8 h-8" />
//                       </div>
//                       <div className="mb-6">
//                         <div className="text-xs mb-1 opacity-75">
//                           Card Number
//                         </div>
//                         <div className="text-lg font-mono">
//                           •••• •••• •••• ••••
//                         </div>
//                       </div>
//                       <div className="flex justify-between">
//                         <div>
//                           <div className="text-xs opacity-75">Cardholder</div>
//                           <div className="text-sm">YOUR NAME</div>
//                         </div>
//                         <div>
//                           <div className="text-xs opacity-75">Expires</div>
//                           <div className="text-sm">MM/YY</div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Form */}
//                     <div className="space-y-4 mb-6">
//                       <div>
//                         <label className="block text-sm font-semibold text-gray-700 mb-2">
//                           Card Number
//                         </label>
//                         <input
//                           type="text"
//                           placeholder="1234 5678 9012 3456"
//                           maxLength="19"
//                           className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
//                         />
//                       </div>
//                       <div className="grid grid-cols-2 gap-4">
//                         <div>
//                           <label className="block text-sm font-semibold text-gray-700 mb-2">
//                             Expiry Date
//                           </label>
//                           <input
//                             type="text"
//                             placeholder="MM/YY"
//                             maxLength="5"
//                             className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
//                           />
//                         </div>
//                         <div>
//                           <label className="block text-sm font-semibold text-gray-700 mb-2">
//                             CVV
//                           </label>
//                           <input
//                             type="text"
//                             placeholder="123"
//                             maxLength="3"
//                             className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
//                           />
//                         </div>
//                       </div>
//                       <div>
//                         <label className="block text-sm font-semibold text-gray-700 mb-2">
//                           Cardholder Name
//                         </label>
//                         <input
//                           type="text"
//                           placeholder="Name on card"
//                           className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
//                         />
//                       </div>
//                     </div>

//                     {/* Amount Display */}
//                     <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-200">
//                       <div className="flex justify-between items-center">
//                         <span className="font-semibold text-gray-700">
//                           Amount to Pay:
//                         </span>
//                         <span className="text-2xl font-bold text-blue-600">
//                           ₹
//                           {parseInt(
//                             selectedSeva?.price
//                               .replace("₹", "")
//                               .replace(",", "")
//                           ) + 50}
//                         </span>
//                       </div>
//                     </div>

//                     {/* Pay Button */}
//                     <button
//                       onClick={handlePaymentSuccess}
//                       className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-4 rounded-xl font-bold hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
//                     >
//                       <FiCheck className="w-5 h-5" />
//                       <span>Pay Securely</span>
//                     </button>
//                   </>
//                 ) : (
//                   <div className="py-8 text-center">
//                     <motion.div
//                       animate={{ rotate: 360 }}
//                       transition={{
//                         duration: 1,
//                         repeat: Infinity,
//                         ease: "linear",
//                       }}
//                       className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full mx-auto mb-4"
//                     />
//                     <p className="text-lg font-semibold text-gray-900 mb-2">
//                       Processing Payment...
//                     </p>
//                     <p className="text-sm text-gray-600">Please wait</p>
//                   </div>
//                 )}
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiSun,
  FiStar,
  FiGift,
  FiClock,
  FiMapPin,
  FiPhone,
  FiMail,
  FiSearch,
  FiX,
  FiCalendar,
  FiCheck,
  FiShare2,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import {
  GiTempleGate,
  GiFlowerPot,
  GiLotus,
  GiIndianPalace,
  GiFire,
  GiBowlOfRice,
  GiClothes,
} from "react-icons/gi";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";

export default function TempleSevasPage() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSeva, setSelectedSeva] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [shareSevaId, setShareSevaId] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const sevaCategories = [
    {
      id: "all",
      name: "All Sevas",
      icon: <GiTempleGate />,
      color: "from-orange-500 to-red-600",
    },
    {
      id: "daily",
      name: "Daily Sevas",
      icon: <FiSun />,
      color: "from-yellow-500 to-orange-600",
    },
    {
      id: "special",
      name: "Special Pujas",
      icon: <FiStar />,
      color: "from-purple-500 to-pink-600",
    },
    {
      id: "festival",
      name: "Festival Sevas",
      icon: <FiGift />,
      color: "from-pink-500 to-red-600",
    },
    {
      id: "abhishekam",
      name: "Abhishekam",
      icon: <GiFlowerPot />,
      color: "from-blue-500 to-cyan-600",
    },
    {
      id: "homa",
      name: "Homa/Homam",
      icon: <GiFire />,
      color: "from-red-500 to-orange-600",
    },
    {
      id: "archana",
      name: "Archana",
      icon: <GiIndianPalace />,
      color: "from-indigo-500 to-purple-600",
    },
    {
      id: "kalyanam",
      name: "Kalyanam",
      icon: <GiLotus />,
      color: "from-rose-500 to-pink-600",
    },
    {
      id: "annadanam",
      name: "Annadanam",
      icon: <GiBowlOfRice />,
      color: "from-green-500 to-emerald-600",
    },
    {
      id: "vasthra",
      name: "Vasthra Seva",
      icon: <GiClothes />,
      color: "from-teal-500 to-cyan-600",
    },
  ];

  const temples = {
    1: {
      name: "Sri Chamundeshwari Temple",
      location: "Mysuru, Karnataka",
      deity: "Goddess Chamundeshwari",
      address: "Chamundi Hills, Mysuru - 570008",
      contact: "+91 821-2512235",
      email: "info@chamundeshwari.org",
      timings: "7:30 AM - 2:00 PM, 3:30 PM - 9:00 PM",
      description:
        "Ancient temple atop Chamundi Hills, dedicated to Goddess Chamundeshwari, the presiding deity of Mysore.",
      facilities: ["Free Prasadam", "Parking", "Accommodation", "Hill View"],
      profileImage:
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    2: {
      name: "Udupi Sri Krishna Temple",
      location: "Udupi, Karnataka",
      deity: "Lord Krishna",
      address: "Car Street, Udupi - 576101",
      contact: "+91 820-2520176",
      email: "info@udupikshetra.org",
      timings: "5:30 AM - 1:00 PM, 3:00 PM - 9:00 PM",
      description:
        "Famous Krishna temple known for its unique idol worship through a silver-plated window.",
      facilities: [
        "Anna Prasadam",
        "Heritage Site",
        "Temple Museum",
        "Vedic School",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
      ],
    },
    3: {
      name: "Gokarna Mahabaleshwara Temple",
      location: "Gokarna, Karnataka",
      deity: "Lord Shiva",
      address: "Gokarna Beach Road, Gokarna - 581326",
      contact: "+91 8386-256320",
      email: "info@gokarna.org",
      timings: "6:00 AM - 1:00 PM, 5:00 PM - 8:30 PM",
      description:
        "One of the seven Mukti Stalas, housing the Atmalinga of Lord Shiva.",
      facilities: [
        "Beach View",
        "Guesthouse",
        "Prasadam Counter",
        "Holy Bath Ghat",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    4: {
      name: "Murudeshwar Temple",
      location: "Murudeshwar, Karnataka",
      deity: "Lord Shiva",
      address: "Murudeshwar Beach, Bhatkal - 581350",
      contact: "+91 8385-260218",
      email: "info@murudeshwar.org",
      timings: "6:00 AM - 8:00 PM",
      description:
        "Famous for its towering 123-feet Shiva statue and scenic coastal location.",
      facilities: [
        "Beach Access",
        "Statue Viewing",
        "Museum",
        "Water Sports Nearby",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    5: {
      name: "Kollur Mookambika Temple",
      location: "Kollur, Karnataka",
      deity: "Goddess Mookambika",
      address: "Kollur Village, Kundapura - 576220",
      contact: "+91 8258-277212",
      email: "info@mookambika.org",
      timings: "4:00 AM - 1:30 PM, 3:00 PM - 9:00 PM",
      description:
        "Ancient Shakti Peetha dedicated to Goddess Mookambika, surrounded by Western Ghats forest.",
      facilities: ["Accommodation", "Annadanam", "Parking", "Kodachadri Trek"],
      profileImage:
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    6: {
      name: "Kukke Subramanya Temple",
      location: "Sullia, Karnataka",
      deity: "Lord Subramanya",
      address: "Kukke Village, Sullia Taluk - 574239",
      contact: "+91 8257-258212",
      email: "info@kukkesubramanya.org",
      timings: "5:30 AM - 2:00 PM, 5:00 PM - 9:00 PM",
      description:
        "Famous temple for Sarpa Dosha rituals, nestled in the Western Ghats.",
      facilities: ["Sarpa Samskara", "River Bath", "Accommodation", "Prasadam"],
      profileImage:
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    7: {
      name: "Dharmasthala Manjunatha Temple",
      location: "Dharmasthala, Karnataka",
      deity: "Lord Manjunatha",
      address: "Dharmasthala, Belthangady - 574216",
      contact: "+91 8256-277255",
      email: "info@dharmasthala.org",
      timings: "6:00 AM - 2:00 PM, 5:30 PM - 9:00 PM",
      description:
        "Unique temple managed by Jain administration dedicated to Lord Shiva, known for free meals.",
      facilities: [
        "Free Meals",
        "Accommodation",
        "Museum",
        "Educational Trust",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    8: {
      name: "Sringeri Sharada Peetham",
      location: "Sringeri, Karnataka",
      deity: "Goddess Sharada",
      address: "Sringeri Village, Chikkamagaluru - 577139",
      contact: "+91 8265-250125",
      email: "info@sringeri.net",
      timings: "6:00 AM - 1:00 PM, 3:00 PM - 8:30 PM",
      description:
        "One of the four Advaita Vedanta mathas established by Adi Shankaracharya.",
      facilities: ["Vedic Learning", "Library", "Guesthouse", "River View"],
      profileImage:
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    9: {
      name: "Talacauvery Temple",
      location: "Bhagamandala, Karnataka",
      deity: "Goddess Kaveri",
      address: "Talacauvery, Kodagu - 571212",
      contact: "+91 8272-228506",
      email: "info@talacauvery.org",
      timings: "6:00 AM - 6:00 PM",
      description: "Sacred birthplace of River Kaveri in the Brahmagiri hills.",
      facilities: [
        "Hill Station",
        "Natural Spring",
        "Scenic Views",
        "Trekking",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    10: {
      name: "Horanadu Annapoorneshwari Temple",
      location: "Horanadu, Karnataka",
      deity: "Goddess Annapoorneshwari",
      address: "Horanadu Village, Chikkamagaluru - 577433",
      contact: "+91 8265-279228",
      email: "info@horanadu.org",
      timings: "6:00 AM - 1:00 PM, 3:00 PM - 9:00 PM",
      description:
        "Beautiful temple in Western Ghats dedicated to Goddess Annapoorneshwari.",
      facilities: [
        "Free Meals",
        "Accommodation",
        "River Nearby",
        "Western Ghats View",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
      ],
    },
  };

  const sevas = [
    {
      id: 1,
      name: "Chamundi Abhisheka",
      templeId: 1,
      category: "abhishekam",
      description:
        "Sacred abhishekam to Goddess Chamundeshwari with milk, honey, and sacred waters",
      duration: "45 mins",
      price: "₹500",
      time: "7:30 AM - 8:15 AM",
      benefits: ["Divine grace", "Protection", "Prosperity"],
      includes: [
        "Milk abhishekam",
        "Honey offering",
        "Flower decoration",
        "Sacred mantras",
      ],
    },
    {
      id: 2,
      name: "Kumkumarchana",
      templeId: 1,
      category: "archana",
      description:
        "Traditional kumkuma archana for the Goddess with 1008 names chanting",
      duration: "30 mins",
      price: "₹300",
      time: "6:00 PM - 6:30 PM",
      benefits: ["Family welfare", "Peace", "Divine blessings"],
      includes: [
        "Kumkuma offering",
        "1008 names chanting",
        "Aarti",
        "Prasadam",
      ],
    },
    {
      id: 3,
      name: "Mahishasura Mardini Archana",
      templeId: 1,
      category: "special",
      description: "Special worship commemorating the victory over Mahishasura",
      duration: "1 hour",
      price: "₹1,100",
      time: "5:00 PM - 6:00 PM",
      benefits: ["Victory over obstacles", "Strength", "Courage"],
      includes: [
        "Special puja",
        "108 names chanting",
        "Naivedyam",
        "Sacred ash",
      ],
    },
    {
      id: 4,
      name: "Ekantha Seva",
      templeId: 2,
      category: "daily",
      description:
        "Evening aarti and special darshan through the silver window",
      duration: "30 mins",
      price: "₹200",
      time: "8:30 PM - 9:00 PM",
      benefits: ["Peaceful sleep", "Mental peace", "Krishna's grace"],
      includes: [
        "Aarti darshan",
        "Special prayers",
        "Tulasi offering",
        "Prasadam",
      ],
    },
    {
      id: 5,
      name: "Krishna Abhisheka",
      templeId: 2,
      category: "abhishekam",
      description: "Milk and honey abhishekam with Vishnu Sahasranama chanting",
      duration: "45 mins",
      price: "₹750",
      time: "6:00 AM - 6:45 AM",
      benefits: ["Spiritual growth", "Devotion", "Divine love"],
      includes: [
        "Milk abhishekam",
        "Sahasranama chanting",
        "Flower decoration",
        "Butter offering",
      ],
    },
    {
      id: 6,
      name: "Tulasi Seva",
      templeId: 2,
      category: "daily",
      description: "Sacred Tulasi plant worship and offering to Lord Krishna",
      duration: "20 mins",
      price: "₹150",
      time: "5:00 PM - 5:20 PM",
      benefits: ["Health", "Purification", "Divine blessings"],
      includes: ["Tulasi worship", "Water offering", "Aarti", "Sacred leaves"],
    },
    {
      id: 7,
      name: "Atmalinga Abhisheka",
      templeId: 3,
      category: "abhishekam",
      description: "Sacred abhishekam to the self-manifested Atmalinga",
      duration: "1 hour",
      price: "₹1,000",
      time: "6:30 AM - 7:30 AM",
      benefits: ["Moksha", "Liberation", "Spiritual awakening"],
      includes: [
        "Special abhishekam",
        "Rudram chanting",
        "Bilva leaves",
        "Sacred ash",
      ],
    },
    {
      id: 8,
      name: "Rudrabhisheka",
      templeId: 3,
      category: "abhishekam",
      description: "11 Rudra abhishekam with Vedic chanting by the sea",
      duration: "2 hours",
      price: "₹3,500",
      time: "7:00 AM - 9:00 AM",
      benefits: ["Health", "Prosperity", "Shiva's blessings"],
      includes: [
        "11 types of abhishekam",
        "Vedic mantras",
        "Complete puja items",
        "Prasadam",
      ],
    },
    {
      id: 9,
      name: "Panchamrita Abhisheka",
      templeId: 3,
      category: "daily",
      description: "Abhishekam with five sacred nectars",
      duration: "30 mins",
      price: "₹500",
      time: "6:00 PM - 6:30 PM",
      benefits: ["Purification", "Peace", "Contentment"],
      includes: ["Five nectars", "Mantras", "Flower offering", "Vibhuti"],
    },
    {
      id: 10,
      name: "Maha Shivratri Abhisheka",
      templeId: 4,
      category: "special",
      description:
        "Grand abhishekam at the world's second tallest Shiva statue",
      duration: "1.5 hours",
      price: "₹2,100",
      time: "6:00 AM - 7:30 AM",
      benefits: ["Massive blessings", "Success", "Protection"],
      includes: [
        "Grand abhishekam",
        "Special puja",
        "Bel patra offering",
        "Prasadam",
      ],
    },
    {
      id: 11,
      name: "Bilva Archana",
      templeId: 4,
      category: "archana",
      description: "Sacred Bilva leaf offering with Shiva mantras",
      duration: "30 mins",
      price: "₹300",
      time: "7:00 AM - 7:30 AM",
      benefits: ["Shiva's grace", "Devotion", "Spiritual merit"],
      includes: ["Bilva leaves", "Mantras", "Water offering", "Aarti"],
    },
    {
      id: 12,
      name: "Mookambika Sahasranama Archana",
      templeId: 5,
      category: "archana",
      description: "Chanting 1000 names of Goddess Mookambika",
      duration: "1 hour",
      price: "₹800",
      time: "6:00 AM - 7:00 AM",
      benefits: ["Knowledge", "Wisdom", "Speech clarity"],
      includes: [
        "1000 names chanting",
        "Flower offering",
        "Kumkuma",
        "Prasadam",
      ],
    },
    {
      id: 13,
      name: "Ganapathi Homa",
      templeId: 1,
      category: "homa",
      description: "Sacred fire ritual to Lord Ganesha for removing obstacles",
      duration: "2 hours",
      price: "₹2,500",
      time: "7:00 AM - 9:00 AM",
      benefits: ["Remove obstacles", "Success", "New beginnings"],
      includes: [
        "Homa ceremony",
        "108 offerings",
        "Vedic chanting",
        "Sacred ash",
      ],
    },
    {
      id: 14,
      name: "Navagraha Homa",
      templeId: 2,
      category: "homa",
      description:
        "Planetary peace fire ritual for harmonizing cosmic influences",
      duration: "3 hours",
      price: "₹5,000",
      time: "6:00 AM - 9:00 AM",
      benefits: ["Planetary peace", "Good fortune", "Health"],
      includes: [
        "Nine planet worship",
        "Fire offerings",
        "Mantras for all planets",
        "Prasadam",
      ],
    },
    {
      id: 15,
      name: "Lakshmi Kalyanam",
      templeId: 5,
      category: "kalyanam",
      description: "Divine marriage ceremony of Goddess Lakshmi",
      duration: "2.5 hours",
      price: "₹3,500",
      time: "9:00 AM - 11:30 AM",
      benefits: ["Wealth", "Prosperity", "Marital harmony"],
      includes: [
        "Complete kalyanam ritual",
        "Decoration",
        "Sacred offerings",
        "Special prasadam",
      ],
    },
    {
      id: 16,
      name: "Annadanam Seva",
      templeId: 7,
      category: "annadanam",
      description: "Sacred food offering service to devotees",
      duration: "Full day",
      price: "₹10,000",
      time: "11:00 AM - 3:00 PM",
      benefits: ["Merit", "Blessings", "Satisfaction"],
      includes: [
        "Feeding 500 devotees",
        "Complete meal",
        "Kitchen seva",
        "Certificate",
      ],
    },
    {
      id: 17,
      name: "Diwali Special Lakshmi Puja",
      templeId: 5,
      category: "festival",
      description: "Grand Lakshmi puja during Diwali festival",
      duration: "2 hours",
      price: "₹2,000",
      time: "6:00 PM - 8:00 PM",
      benefits: ["Wealth", "Prosperity", "Divine grace"],
      includes: [
        "Special decorations",
        "Lakshmi puja",
        "Aarti",
        "Sweets prasadam",
      ],
    },
    {
      id: 18,
      name: "Vasthra Alankara",
      templeId: 2,
      category: "vasthra",
      description: "Offering of new garments to the deity",
      duration: "1 hour",
      price: "₹1,500",
      time: "10:00 AM - 11:00 AM",
      benefits: ["Divine blessings", "Fulfillment", "Grace"],
      includes: [
        "New silk vasthra",
        "Decoration",
        "Special darshan",
        "Blessed cloth",
      ],
    },
    {
      id: 19,
      name: "Ugadi Festival Seva",
      templeId: 8,
      category: "festival",
      description: "New Year celebration with special rituals",
      duration: "3 hours",
      price: "₹1,800",
      time: "8:00 AM - 11:00 AM",
      benefits: ["New beginnings", "Good fortune", "Success"],
      includes: [
        "Special puja",
        "Ugadi pachadi",
        "New year blessings",
        "Prasadam",
      ],
    },
    {
      id: 20,
      name: "Ayudha Puja",
      templeId: 1,
      category: "festival",
      description: "Worship of instruments and vehicles during Navaratri",
      duration: "1.5 hours",
      price: "₹800",
      time: "4:00 PM - 5:30 PM",
      benefits: ["Tool blessings", "Success in work", "Protection"],
      includes: ["Tools worship", "Special mantras", "Kumkuma", "Prasadam"],
    },
  ];

  const filteredSevas = sevas.filter((seva) => {
    const temple = temples[seva.templeId];
    const matchesCategory =
      selectedCategory === "all" || seva.category === selectedCategory;
    const matchesSearch =
      searchQuery === "" ||
      seva.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      seva.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      temple.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      temple.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      temple.deity.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Auto-slide gallery images
  useEffect(() => {
    if (selectedSeva) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => {
          const temple = temples[selectedSeva.templeId];
          return (prevIndex + 1) % temple.galleryImages.length;
        });
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [selectedSeva]);

  // Reset image index when modal opens
  useEffect(() => {
    if (selectedSeva) {
      setCurrentImageIndex(0);
    }
  }, [selectedSeva]);

  const handlePrevImage = () => {
    const temple = temples[selectedSeva.templeId];
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? temple.galleryImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    const temple = temples[selectedSeva.templeId];
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % temple.galleryImages.length
    );
  };

  const handleShare = (platform, seva) => {
    const temple = temples[seva.templeId];
    const shareText = `Check out ${seva.name} at ${temple.name}, ${temple.location}`;
    const shareUrl = window.location.href;

    let url = "";
    switch (platform) {
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl
        )}`;
        break;
      case "instagram":
        navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
        alert("Link copied to clipboard! Share it on Instagram.");
        return;
      case "youtube":
        navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
        alert("Link copied to clipboard!");
        return;
      default:
        return;
    }

    if (url) {
      window.open(url, "_blank", "width=600,height=400");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-yellow-50 flex flex-col lg:flex-row mt-16 sm:mt-20">
      {/* Mobile Header with Menu Toggle */}
      <div className="lg:hidden bg-white shadow-md p-3 sm:p-4 flex items-center justify-between sticky top-0 z-[60]">
        <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <GiTempleGate className="text-orange-600" />
          Temple Sevas
        </h2>
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="p-2 rounded-lg bg-orange-100 text-orange-600"
        >
          {mobileMenuOpen ? (
            <FiX className="text-xl" />
          ) : (
            <FiSearch className="text-xl" />
          )}
        </button>
      </div>

      {/* Mobile Filter Dropdown */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white shadow-lg border-b border-gray-200 overflow-hidden z-[55]"
          >
            <div className="p-4 max-h-[70vh] overflow-y-auto">
              <h3 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
                <GiTempleGate className="text-orange-600" />
                Categories
              </h3>
              <div className="grid grid-cols-2 gap-2">
                {sevaCategories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setMobileMenuOpen(false);
                    }}
                    className={`flex flex-col items-center justify-center gap-2 px-3 py-3 rounded-xl font-medium transition-all duration-200 text-xs ${
                      selectedCategory === category.id
                        ? `bg-gradient-to-r ${category.color} text-white shadow-lg transform scale-105`
                        : "text-gray-700 bg-gray-50 hover:bg-gray-100 border border-gray-200"
                    }`}
                  >
                    <span className="text-2xl">{category.icon}</span>
                    <span className="text-center leading-tight">
                      {category.name}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Desktop Left Sidebar - Filters */}
      <div className="hidden lg:block w-56 xl:w-72 bg-white shadow-lg border-r border-gray-200 flex-shrink-0 self-start sticky top-20 mt-6 mr-4 rounded-lg max-h-[calc(100vh-6rem)] overflow-y-auto">
        <div className="p-4 lg:p-5 xl:p-6">
          <h3 className="text-base lg:text-lg font-bold text-gray-800 mb-3 lg:mb-4 flex items-center gap-2">
            <GiTempleGate className="text-orange-600 text-lg lg:text-xl" />
            Categories
          </h3>
          <div className="space-y-2">
            {sevaCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-all duration-200 text-sm ${
                  selectedCategory === category.id
                    ? `bg-gradient-to-r ${category.color} text-white shadow-lg transform scale-105`
                    : "text-gray-700 hover:bg-gray-50 border border-gray-200 hover:border-gray-300"
                }`}
              >
                <span className="text-xl flex-shrink-0">{category.icon}</span>
                <span className="truncate text-left">{category.name}</span>
                {selectedCategory === category.id && (
                  <FiCheck className="ml-auto flex-shrink-0" />
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto lg:ml-0">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-orange-600 via-red-600 to-orange-700 text-white py-4 sm:py-6 lg:py-8">
          <div className="container mx-auto px-3 sm:px-4 lg:px-6">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center"
            >
              <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold mb-1 sm:mb-2">
                Temple Sevas
              </h1>
              <p className="text-xs sm:text-sm lg:text-base text-orange-100 max-w-2xl mx-auto px-2 sm:px-4">
                Experience divine blessings through sacred temple rituals
              </p>
            </motion.div>

            {/* Search Bar */}
            <div className="mt-3 sm:mt-4 lg:mt-6 max-w-xl mx-auto relative">
              <FiSearch className="absolute left-3 lg:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-base lg:text-lg" />
              <input
                type="text"
                placeholder="Search sevas, temples, or deities..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-9 sm:pl-10 lg:pl-11 pr-9 sm:pr-10 lg:pr-4 py-2 sm:py-2.5 lg:py-3 rounded-full text-gray-800 focus:outline-none focus:ring-2 lg:focus:ring-3 focus:ring-orange-300 shadow-xl text-xs sm:text-sm"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  <FiX />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Sevas Grid */}
        <div className="container mx-auto px-2 sm:px-3 lg:px-6 py-3 sm:py-4 lg:py-6">
          {filteredSevas.length === 0 ? (
            <div className="text-center py-12 lg:py-20">
              <GiTempleGate className="text-4xl lg:text-6xl text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl lg:text-2xl font-bold text-gray-600 mb-2">
                No sevas found
              </h3>
              <p className="text-sm lg:text-base text-gray-500 mb-6">
                Try adjusting your search or filter
              </p>
              <button
                onClick={() => {
                  setSearchQuery("");
                  setSelectedCategory("all");
                }}
                className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 lg:px-8 py-2.5 lg:py-3 rounded-full font-semibold hover:from-orange-600 hover:to-red-700 transition-all duration-300 shadow-lg text-sm"
              >
                Reset Filters
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-2.5 sm:gap-3 lg:gap-4">
              {filteredSevas.map((seva, index) => {
                const temple = temples[seva.templeId];
                return (
                  <motion.div
                    key={seva.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.03 }}
                    className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 group relative"
                  >
                    {/* Share Icon */}
                    <div className="absolute top-2 right-2 z-10">
                      <div className="relative">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShareSevaId(
                              shareSevaId === seva.id ? null : seva.id
                            );
                          }}
                          className="bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-lg hover:bg-white transition-all duration-200"
                        >
                          <FiShare2 className="text-orange-600 text-sm" />
                        </button>

                        {/* Social Media Icons */}
                        <AnimatePresence>
                          {shareSevaId === seva.id && (
                            <motion.div
                              initial={{ opacity: 0, scale: 0.8, y: -10 }}
                              animate={{ opacity: 1, scale: 1, y: 0 }}
                              exit={{ opacity: 0, scale: 0.8, y: -10 }}
                              className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-xl p-2 flex flex-col gap-2"
                            >
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare("facebook", seva);
                                }}
                                className="p-2 rounded-full bg-blue-50 hover:bg-blue-100 transition-colors"
                              >
                                <FaFacebook className="text-blue-600 text-lg" />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare("instagram", seva);
                                }}
                                className="p-2 rounded-full bg-pink-50 hover:bg-pink-100 transition-colors"
                              >
                                <FaInstagram className="text-pink-600 text-lg" />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare("youtube", seva);
                                }}
                                className="p-2 rounded-full bg-red-50 hover:bg-red-100 transition-colors"
                              >
                                <FaYoutube className="text-red-600 text-lg" />
                              </button>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>

                    {/* Card Image - Temple Profile Image Only */}
                    <div
                      onClick={() => setSelectedSeva(seva)}
                      className="relative h-24 sm:h-28 overflow-hidden cursor-pointer"
                    >
                      <img
                        src={temple?.profileImage}
                        alt={temple?.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                      {/* Temple Info Overlay */}
                      <div className="absolute bottom-0 left-0 right-0 p-2 text-white">
                        <p className="text-[11px] sm:text-xs font-semibold truncate">
                          {temple?.name}
                        </p>
                        <p className="text-[10px] sm:text-xs opacity-90 truncate flex items-center gap-1">
                          <FiMapPin className="flex-shrink-0 text-[9px] sm:text-[10px]" />
                          {temple?.location}
                        </p>
                      </div>
                    </div>

                    {/* Card Body */}
                    <div
                      onClick={() => setSelectedSeva(seva)}
                      className="p-2.5 sm:p-3 cursor-pointer"
                    >
                      <h3 className="text-xs sm:text-sm font-bold text-gray-800 mb-1 truncate">
                        {seva.name}
                      </h3>
                      <p className="text-[11px] sm:text-xs text-gray-600 mb-2 line-clamp-2">
                        {seva.description}
                      </p>

                      {/* Quick Info */}
                      <div className="space-y-1 mb-2">
                        <div className="flex items-center gap-1.5 text-[11px] sm:text-xs text-gray-600">
                          <GiLotus className="text-orange-600 flex-shrink-0 text-xs sm:text-sm" />
                          <span className="truncate">{temple?.deity}</span>
                        </div>
                        <div className="flex items-center gap-1.5 text-[11px] sm:text-xs text-gray-600">
                          <FiClock className="text-orange-600 flex-shrink-0 text-xs sm:text-sm" />
                          <span className="truncate">{seva.duration}</span>
                        </div>
                      </div>

                      {/* Benefits */}
                      <div className="flex flex-wrap gap-1 mb-2.5 sm:mb-3">
                        {seva.benefits.slice(0, 2).map((benefit, idx) => (
                          <span
                            key={idx}
                            className="px-1.5 sm:px-2 py-0.5 bg-orange-50 text-orange-700 rounded-full text-[9px] sm:text-[10px] font-medium"
                          >
                            ✨ {benefit}
                          </span>
                        ))}
                      </div>

                      {/* View Details Button */}
                      <button className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white py-1.5 sm:py-2 rounded-lg font-semibold hover:from-orange-600 hover:to-red-700 transition-all duration-300 shadow-md text-[11px] sm:text-xs flex items-center justify-center gap-1">
                        View Details
                      </button>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Full Screen Details Modal - (continuing in next part due to length) */}
      <AnimatePresence>
        {selectedSeva && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedSeva(null)}
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40 flex items-center justify-center"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-white w-full h-full overflow-auto"
            >
              {/* Modal Header with Close Button */}
              <div className="sticky top-0 bg-gradient-to-r from-orange-600 to-red-600 text-white p-3 sm:p-4 lg:p-6 z-30 shadow-lg mt-20">
                <button
                  onClick={() => setSelectedSeva(null)}
                  className="absolute top-2 right-2 sm:top-4 sm:right-4 p-1.5 sm:p-2 hover:bg-white/20 rounded-full transition-colors"
                >
                  <FiX className="text-xl sm:text-2xl" />
                </button>
                <h2 className="text-lg sm:text-xl lg:text-2xl font-bold mb-1 sm:mb-2 pr-10 sm:pr-12">
                  {selectedSeva.name}
                </h2>
                <p className="text-orange-100 text-xs sm:text-sm">
                  {temples[selectedSeva.templeId]?.name}
                </p>
                <p className="text-orange-100 text-xs flex items-center gap-1 mt-1">
                  <FiMapPin /> {temples[selectedSeva.templeId]?.location}
                </p>
              </div>

              {/* Modal Body */}
              <div className="p-3 sm:p-4 lg:p-6 space-y-4 sm:space-y-5 lg:space-y-6 max-w-6xl mx-auto">
                {/* Image Gallery Slider */}
                <div className="relative rounded-xl overflow-hidden shadow-2xl">
                  <div className="relative h-48 sm:h-64 lg:h-80">
                    <AnimatePresence mode="wait">
                      <motion.img
                        key={currentImageIndex}
                        src={
                          temples[selectedSeva.templeId]?.galleryImages[
                            currentImageIndex
                          ]
                        }
                        alt={`${temples[selectedSeva.templeId]?.name} - Image ${
                          currentImageIndex + 1
                        }`}
                        className="w-full h-full object-cover"
                        initial={{ opacity: 0, x: 100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -100 }}
                        transition={{ duration: 0.5 }}
                      />
                    </AnimatePresence>

                    {/* Navigation Buttons */}
                    <button
                      onClick={handlePrevImage}
                      className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm p-2 sm:p-3 rounded-full shadow-lg hover:bg-white transition-all duration-200 group"
                    >
                      <FiChevronLeft className="text-orange-600 text-lg sm:text-xl group-hover:scale-110 transition-transform" />
                    </button>
                    <button
                      onClick={handleNextImage}
                      className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm p-2 sm:p-3 rounded-full shadow-lg hover:bg-white transition-all duration-200 group"
                    >
                      <FiChevronRight className="text-orange-600 text-lg sm:text-xl group-hover:scale-110 transition-transform" />
                    </button>

                    {/* Image Indicators */}
                    <div className="absolute bottom-2 sm:bottom-4 left-1/2 -translate-x-1/2 flex gap-1 sm:gap-2">
                      {temples[selectedSeva.templeId]?.galleryImages.map(
                        (_, idx) => (
                          <button
                            key={idx}
                            onClick={() => setCurrentImageIndex(idx)}
                            className={`w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full transition-all duration-300 ${
                              idx === currentImageIndex
                                ? "bg-white w-6 sm:w-8"
                                : "bg-white/50 hover:bg-white/75"
                            }`}
                          />
                        )
                      )}
                    </div>

                    {/* Image Counter */}
                    <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-black/60 backdrop-blur-sm text-white px-2 py-0.5 sm:px-3 sm:py-1 rounded-full text-xs sm:text-sm">
                      {currentImageIndex + 1} /{" "}
                      {temples[selectedSeva.templeId]?.galleryImages.length}
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2 flex items-center gap-2">
                    <GiLotus className="text-orange-600" />
                    About This Seva
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {selectedSeva.description}
                  </p>
                </div>

                {/* What's Included */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                    <FiCheck className="text-orange-600" />
                    What's Included
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {selectedSeva.includes.map((item, idx) => (
                      <div
                        key={idx}
                        className="flex items-center gap-2 text-sm text-gray-700"
                      >
                        <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Benefits */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                    <FiStar className="text-orange-600" />
                    Spiritual Benefits
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {selectedSeva.benefits.map((benefit, idx) => (
                      <span
                        key={idx}
                        className="px-4 py-2 bg-gradient-to-r from-orange-50 to-red-50 text-orange-700 rounded-full text-sm font-medium border border-orange-200"
                      >
                        ✨ {benefit}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Temple Details */}
                <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-5 border border-orange-100">
                  <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <GiTempleGate className="text-orange-600" />
                    Temple Information
                  </h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Temple</p>
                      <p className="font-semibold text-gray-800 text-sm">
                        {temples[selectedSeva.templeId]?.name}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Deity</p>
                      <p className="font-semibold text-gray-800 text-sm">
                        {temples[selectedSeva.templeId]?.deity}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Location</p>
                      <p className="font-semibold text-gray-800 text-sm flex items-center gap-1">
                        <FiMapPin className="text-orange-600" />
                        {temples[selectedSeva.templeId]?.location}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">
                        Temple Timings
                      </p>
                      <p className="font-semibold text-gray-800 text-xs">
                        {temples[selectedSeva.templeId]?.timings}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Contact</p>
                      <p className="font-semibold text-gray-800 text-sm flex items-center gap-1">
                        <FiPhone className="text-orange-600" />
                        {temples[selectedSeva.templeId]?.contact}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Email</p>
                      <p className="font-semibold text-gray-800 text-sm flex items-center gap-1">
                        <FiMail className="text-orange-600" />
                        {temples[selectedSeva.templeId]?.email}
                      </p>
                    </div>
                  </div>

                  <div className="mt-4">
                    <p className="text-xs text-gray-600 mb-1">Address</p>
                    <p className="text-gray-700 text-sm">
                      {temples[selectedSeva.templeId]?.address}
                    </p>
                  </div>

                  {/* Temple Description */}
                  <div className="mt-4">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      {temples[selectedSeva.templeId]?.description}
                    </p>
                  </div>

                  {/* Facilities */}
                  {temples[selectedSeva.templeId]?.facilities && (
                    <div className="mt-4">
                      <p className="text-xs text-gray-600 mb-2">
                        Facilities Available
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {temples[selectedSeva.templeId].facilities.map(
                          (facility, idx) => (
                            <span
                              key={idx}
                              className="px-3 py-1 bg-white text-gray-700 rounded-full text-xs font-medium border border-gray-200"
                            >
                              ✓ {facility}
                            </span>
                          )
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
